import {CheckInFormValues, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredDriverLicenseNumber, validateRequiredTruckLicensePlateNumber, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Truck Only check-in.
 * Covers: TRUCK_ONLY, TRUCK_ONLY_25.
 * Required: driverFirstName, driverLastName, driverLicenseNumber, truckLicensePlateNumber.
 */
export const validateTruckOnlyForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredDriverLicenseNumber(values.driverLicenseNumber) ??
  validateRequiredTruckLicensePlateNumber(values.truckLicensePlateNumber) ??
  validateOptionalScacCode(values.scacCode);
